import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Typography } from '@platform-ui/design-system';
import { GenericWCWrapper } from '../utils';
export var DSTypography = /*#__PURE__*/function (_GenericWCWrapper) {
  _inherits(DSTypography, _GenericWCWrapper);

  var _super = _createSuper(DSTypography);

  function DSTypography() {
    _classCallCheck(this, DSTypography);

    return _super.call(this, Typography);
  }

  return DSTypography;
}(GenericWCWrapper);

_defineProperty(DSTypography, "_props", ['key'].concat(_toConsumableArray(Object.keys(Typography['__docgenInfo'].props))));
//# sourceMappingURL=Typography.js.map